import styled from 'styled-components';

export default styled.ul`
  border-top: solid 1px ${props => props.theme.colors.grey4};
  list-style: none;
  margin: 0 0.75rem;
  padding: 1.3rem 0;

  li {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    padding: 1rem 0;
  }

  .label {
    width: 143px;
    flex-shrink: 0;

    h4 {
      text-transform: uppercase;
      letter-spacing: ${props => props.theme.letterSpacing.label};
    }

    h5 {
      color: ${props => props.theme.colors.claytonBlue};
    }
  }

  .bar {
    flex-grow: 1;
    height: 1.625rem;
    position: relative;

    .fill {
      width: 100%;
      height: 100%;
      background: ${props => props.theme.colors.blue30};
    }

    &.new {
      .fill {
        background: ${props => props.theme.colors.claytonGreen};
      }
    }
  }
`;
